import { useEffect } from "react";
import { createRoot } from "react-dom/client";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { isApiAlertActive, isTokenInvalidText, showSessionExpiredAlert } from "./apiAlert";

const TOAST_HOST_ID = "toastify-host";
let toastRoot = null;

const toMessage = (msg) => {
  if (msg == null || msg === "") return "";
  return typeof msg === "string" ? msg : String(msg);
};

export const notifySuccess = (msg) => {
  if (isApiAlertActive()) return;
  const m = toMessage(msg);
  if (!m) return;
  toast.success(m);
};

export const notifyError = (msg) => {
  if (isApiAlertActive()) return;
  const m = toMessage(msg);
  if (!m) return;

  if (isTokenInvalidText(m) || /session expired/i.test(m)) {
    showSessionExpiredAlert();
    return;
  }

  toast.error(m);
};

export const notifyWarn = (msg) => {
  if (isApiAlertActive()) return;
  const m = toMessage(msg);
  if (!m) return;
  toast.warn(m);
};

export const notifyInfo = (msg) => {
  if (isApiAlertActive()) return;
  const m = toMessage(msg);
  if (!m) return;
  toast.info(m);
};

const mountToastContainer = () => {
  if (typeof document === "undefined" || toastRoot) return;

  let hostEl = document.getElementById(TOAST_HOST_ID);
  if (!hostEl) {
    hostEl = document.createElement("div");
    hostEl.id = TOAST_HOST_ID;
    document.body.appendChild(hostEl);
  }

  toastRoot = createRoot(hostEl);
  toastRoot.render(
    <ToastContainer
      position="top-right"
      autoClose={2000}
      hideProgressBar
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss={false}
      draggable
      pauseOnHover
      theme="colored"
      style={{ zIndex: 20000 }}
    />
  );
};

/** Safe to render in Layout + pages — only one ToastContainer is ever mounted. */
const Toastify = () => {
  useEffect(() => {
    mountToastContainer();
  }, []);

  return null;
};

export default Toastify;
